<template>
  <div></div>
  <!-- <div class="gps-container">
    <h3>GPS 定位信息</h3>
    <div v-if="isLoading"
         class="loading">定位中...</div>

    <div v-if="positionInfo"
         class="position-info">
      <p>纬度：{{ positionInfo.latitude }}</p>
      <p>经度：{{ positionInfo.longitude }}</p>
      <p>精度（米）：{{ positionInfo.accuracy }}</p>
      <p>获取时间：{{ positionInfo.timestamp | formatTime }}</p>

      <div v-if="isGeoLoading"
           class="loading small">解析地址中...</div>
      <div v-if="addressInfo"
           class="address-info">
        <p>📍 解析地址：{{ addressInfo.formatted_addresses }}</p>
        <p>省：{{ addressInfo.province }}</p>
        <p>市：{{ addressInfo.city }}</p>
        <p>区：{{ addressInfo.district }}</p>
        <p>街道：{{ addressInfo.street }}</p>
      </div>
      <div v-if="geoErrorMsg"
           class="error-msg small">{{ geoErrorMsg }}</div>
    </div>

    <div v-if="errorMsg"
         class="error-msg">{{ errorMsg }}</div>
  </div> -->
</template>

<script>
import { mapState } from 'vuex'
import Tmap from '../../api/model/tmap'
export default {
  name: 'GPSLocation',
  data() {
    return {
      isLoading: false, // 定位加载状态
      positionInfo: null, // 存储定位信息
      errorMsg: '', // 定位错误信息
      watchId: null, // 监听位置变化的ID
      isGeoLoading: false, // 逆地理编码加载状态
      addressInfo: null, // 解析后的地址信息
      geoErrorMsg: '' // 逆地理编码错误信息
    }
  },
  filters: {
    // 时间戳格式化过滤器
    formatTime(timestamp) {
      return new Date(timestamp).toLocaleString()
    }
  },
  // 组件挂载后立即执行定位
  mounted() {
    this.getGPSInfo()
  },
  methods: {
    // 核心方法：获取GPS信息
    getGPSInfo() {
      // 重置状态
      this.isLoading = true
      this.errorMsg = ''
      this.positionInfo = null
      this.addressInfo = null
      this.geoErrorMsg = ''

      // 1. 检查浏览器是否支持Geolocation API
      if (!navigator.geolocation) {
        this.errorMsg = '你的浏览器不支持GPS定位功能，请升级或更换浏览器'
        this.isLoading = false
        return
      }

      // 2. 成功获取位置的回调
      const successCallback = (position) => {
        this.isLoading = false
        // 提取核心定位信息
        this.positionInfo = {
          latitude: position.coords.latitude, // 纬度（WGS84）
          longitude: position.coords.longitude, // 经度（WGS84）
          accuracy: position.coords.accuracy, // 定位精度（米）
          altitude: position.coords.altitude, // 海拔（null表示不支持）
          timestamp: position.timestamp // 定位时间戳
        }

        this.getAddressByLocation()
      }

      const errorCallback = (error) => {
        this.isLoading = false
        switch (error.code) {
          case error.PERMISSION_DENIED:
            this.$toast('你拒绝了位置权限请求，无法获取GPS信息')
            break
          case error.POSITION_UNAVAILABLE:
            this.$toast('位置信息不可用')
            break
          case error.TIMEOUT:
            this.$toast('获取位置信息超时')
            break
          case error.UNKNOWN_ERROR:
            this.$toast('未知错误，无法获取位置信息')
            break
        }
      }

      navigator.geolocation.getCurrentPosition(successCallback, errorCallback, {
        enableHighAccuracy: true, // 高精度模式（耗电但更准）
        timeout: 10000, // 超时时间10秒
        maximumAge: 0 // 不使用缓存，每次都获取新位置
      })
    },

    wgs84ToGcj02(lng, lat) {
      const pi = Math.PI
      const a = 6378245.0 // 长半轴
      const ee = 0.00669342162296594323 // 偏心率平方
      
      // 超出中国范围不转换
      if (!this.isInChina(lng, lat)) {
        return { lng, lat }
      }

      let dLat = this.transformLat(lng - 105.0, lat - 35.0)
      let dLng = this.transformLng(lng - 105.0, lat - 35.0)
      const radLat = lat / 180.0 * pi
      let magic = Math.sin(radLat)
      magic = 1 - ee * magic * magic
      const sqrtMagic = Math.sqrt(magic)
      dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * pi)
      dLng = (dLng * 180.0) / (a / sqrtMagic * Math.cos(radLat) * pi)
      const mgLat = lat + dLat
      const mgLng = lng + dLng
      return { lng: mgLng, lat: mgLat }
    },

    // 纬度转换
    transformLat(x, y) {
      let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
      ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0
      ret += (20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin(y / 3.0 * Math.PI)) * 2.0 / 3.0
      ret += (160.0 * Math.sin(y / 12.0 * Math.PI) + 320 * Math.sin(y * Math.PI / 30.0)) * 2.0 / 3.0
      return ret
    },

    // 经度转换
    transformLng(x, y) {
      let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
      ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0
      ret += (20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin(x / 3.0 * Math.PI)) * 2.0 / 3.0
      ret += (150.0 * Math.sin(x / 12.0 * Math.PI) + 300.0 * Math.sin(x / 30.0 * Math.PI)) * 2.0 / 3.0
      return ret
    },

    // 判断是否在中国范围内
    isInChina(lng, lat) {
      return (lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55)
    },

    async getAddressByLocation() {
      try {
        this.isGeoLoading = true
        this.geoErrorMsg = ''

        const gcj02 = this.wgs84ToGcj02(
          this.positionInfo.longitude,
          this.positionInfo.latitude
        )
        
        const response=await Tmap.geo({Latitude:gcj02.lat,Longitude:gcj02.lng})
        console.log(response)

        if (response.success) {
          const result=response.data.result;
          this.addressInfo = {
            formatted_addresses: result.formatted_addresses.standard_address,
            province: result.address_component.province,
            city: result.address_component.city,
            district: result.address_component.district,
            street: result.address_component.street
          }
            this.signCheckLocation.lat = result.location.lat
            this.signCheckLocation.lng = result.location.lng
            this.signCheckLocation.address = result.formatted_addresses.standard_address
            this.signCheckLocation.country = result.address_component.nation
            this.signCheckLocation.province = result.address_component.province
            this.signCheckLocation.city = result.address_component.city
            this.signCheckLocation.district = result.address_component.district
            // this.signCheckLocation.township = data.addressComponent.township
            this.signCheckLocation.street =result.address_component.street
            this.signCheckLocation.streetNumber = result.address_component.street_number
        } else {
          this.geoErrorMsg = `地址解析失败：${response.data.message}`
        }
      } catch (error) {
        console.error('逆地理编码接口调用失败：', error)
        this.geoErrorMsg = '地址解析失败，请检查网络或稍后重试'
      } finally {
        this.isGeoLoading = false
      }
    },

    watchGPS() {
      if (!navigator.geolocation) return
      this.watchId = navigator.geolocation.watchPosition(
        (position) => {
          console.log('位置变化：', position.coords)
          this.positionInfo = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
            timestamp: position.timestamp
          }
          // 位置变化时重新解析地址
          this.getAddressByLocation()
        },
        (error) => {
          console.error('监听位置失败：', error)
        }
      )
    },

    stopWatchGPS() {
      if (this.watchId) {
        navigator.geolocation.clearWatch(this.watchId)
        this.watchId = null
      }
    }
  },
  computed: {
    ...mapState('loacationAbout', ['signCheckLocation'])
  },
  beforeDestroy() {
    this.stopWatchGPS()
  }
}
</script>

<style scoped>
.gps-container {
  padding: 20px;
}
.loading {
  margin-top: 10px;
  color: #666;
}
.loading.small {
  margin-top: 5px;
  font-size: 14px;
}
.position-info {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.address-info {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #ddd;
}
.error-msg {
  margin-top: 20px;
  color: red;
}
.error-msg.small {
  margin-top: 5px;
  font-size: 14px;
}
</style>